
import Vue from "vue";


export async function fetchNotifications({ commit }, page) {
    try {
      const { data } = await Vue.axios({
        url: `/frontend/notifications`, params: { page }
      });
      commit("notifications/setNotifications", data.notifications, {root: true});
      commit("notifications/setTotalUnseenNotifications", data.total_unseen_notifications,  {root: true});
    } catch (e) {
      commit("notificationsError", e.message);
    } finally {
    }
  }

  export async function updateUserNotification({ commit }, id) {
    try {
      await Vue.axios({
        method: 'GET',
        url: `/frontend/notifications/view_at_notification/?id=${id}`,
      });
      dispatch("fetchNotifications");
    } catch (e) {
      commit('notificationsError', e.message)
    } finally {
    }
  }